<template>
  <div>
    <ul class="colorGrey accountMenuList">
      <li
        :class="{ navLink: cards[0] !== MENU_ITEM_ACCOUNT_DETAILS }"
        class="paddingNormalTop paddingNormalBottom"
        @click="insertAccountMenu(MENU_ITEM_ACCOUNT_DETAILS)"
      >
        <div class="listItemNotificationBadge backgroundColorTransparent hideOnMobile" />
        Account
      </li>
      <li
        :class="{ navLink: cards[0] !== MENU_ITEM_BIDS }"
        class="paddingNormalTop paddingNormalBottom"
        @click="insertAccountMenu(MENU_ITEM_BIDS)"
      >
        <div class="listItemNotificationBadge backgroundColorTransparent hideOnMobile" />
        Bids
      </li>
      <li
        :class="{ navLink: cards[0] !== MENU_ITEM_FAVORITES }"
        class="paddingNormalTop paddingNormalBottom"
        @click="insertAccountMenu(MENU_ITEM_FAVORITES)"
      >
        <div class="listItemNotificationBadge backgroundColorTransparent hideOnMobile" />
        Favorites
      </li>
      <li
        :class="{ navLink: cards[0] !== MENU_ITEM_NOTIFICATIONS }"
        class="paddingNormalTop paddingNormalBottom"
        @click="insertAccountMenu(MENU_ITEM_NOTIFICATIONS)"
      >
        <div class="listItemNotificationBadge backgroundColorTransparent hideOnMobile" />
        Alerts
      </li>
      <li
        :class="{ navLink: cards[0] !== MENU_ITEM_INVOICES }"
        class="paddingNormalTop paddingNormalBottom"
        @click="insertAccountMenu(MENU_ITEM_INVOICES)"
      >
        <div
          class="listItemNotificationBadge hideOnMobile"
          :class="{ backgroundColorTransparent: !hasUnpaidInvoice }"
        />
        <span class="hideOnMobile">Invoices</span>
        <span
          class="hideOnDesktop"
          :class="{ colorError: hasUnpaidInvoice }"
        >Invoices</span>
      </li>
      <!-- <li v-bind:class="{ navLink: cards[0] !== 'Shipping'}"  class="paddingNormalTop paddingNormalBottom" @click="insertAccountMenu('Shipping')">
				<div class="listItemNotificationBadge hideOnMobile" v-bind:class="{ backgroundColorTransparent: (!hasShippingOrderThatRequiresAttention && !hasItemThatRequiresFullfillment) }"></div>
				<span class="hideOnMobile">Past Shipments</span>
				<span class="hideOnDesktop" v-bind:class="{ colorError: (hasShippingOrderThatRequiresAttention && !hasItemThatRequiresFullfillment) }">Past Shippments</span>
			</li> -->
      <li
        v-if="hasCoInventory === true"
        :class="{ navLink: cards[0] !== 'Consignments'}"
        class="paddingNormalTop paddingNormalBottom"
        @click="insertAccountMenu('Consignments')"
      >
        <div class="listItemNotificationBadge backgroundColorTransparent hideOnMobile" />
        Consignments
      </li>
      <li class="paddingNormalTop paddingNormalBottom">
        <div class="listItemNotificationBadge backgroundColorTransparent hideOnMobile" />
        <a
          class="navLink"
          href="/sign-out/"
        >Sign out</a>
      </li>
    </ul>
  </div>
</template>

<script>
import * as menuConstants from '../../constants/menu'

export default {
	name: 'CreateAccountCard',
	data () {
		return {
			'hasBidsNotification': false,
			...menuConstants
		}
	},
	computed: {
		cards: function () {
			return this.$store.getters.accountCardHistory
		},
		customer () {
			return this.$store.getters.customer
		},
		customerDisplayName: function () {
			return this.$store.getters.customerDisplayName
		},
		customerEmailAddress: function () {
			return this.$store.getters.customerEmailAddress
		},
		hasUnpaidInvoice: function () {
			return this.$store.getters.hasUnpaidInvoice
		},
		hasShippingOrderThatRequiresAttention: function () {
			return this.$store.getters.hasShippingOrderThatRequiresAttention
		},
		hasItemThatRequiresFullfillment: function () {
			return this.$store.getters.hasItemThatRequiresFullfillment
		},
		hasCoInventory () {
			return this.customer && this.customer.cos && this.customer.cos.inventory_count > 0
		}
	},
	watch: {
		cards: function () {
			if (this.cards.length > 1 && this.cards[0] === menuConstants.MENU_ITEM_ACCOUNT_DETAILS) {
				this.$store.dispatch('deleteAccountHistory')
			}
		}
	},
	mounted () {
		// Add a popstate event listener, so we can handle the browser back button
		window.addEventListener('popstate', this.handlePopstate)
	},
	methods: {
		// This function will be called when the browser back button is clicked
		handlePopstate () {
			// Hash is empty, so close the account modal
			if (window.location.hash === '') {
				this.$store.dispatch('clearAllAccountHistory')
				this.$store.dispatch('hideModal')
				return
			}

			if (this.cards.length > 1) {
				// Did we just leave the Invoice Item page and go back to the Invoices page?
				if (this.cards.slice(0, 1)[0] === menuConstants.MENU_ITEM_INVOICE_ITEM && window.location.hash === menuConstants.URL_HASH_INVOICES) {
					this.$store.dispatch('deleteAccountHistory')
				}
			} else {
				// Did they go back to the Account Details page?
				if (window.location.hash === menuConstants.URL_HASH_ACCOUNT_DETAILS && this.cards.slice(0, 1)[0] !== menuConstants.MENU_ITEM_ACCOUNT_DETAILS) {
					this.$store.dispatch('clearAllAccountHistory')
					this.$store.dispatch('insertAccountHistory', menuConstants.MENU_ITEM_ACCOUNT_DETAILS)
				}
			}
		},
		beforeDestroy () {
			// Remove the popstate event listener to avoid memory leaks
			window.removeEventListener('popstate', this.handlePopstate)
		},
		insertAccountMenu (payload) {
			this.cards.forEach(() => {
				this.$store.dispatch('deleteAccountHistory')
			})

			this.$store.dispatch('insertAccountHistory', payload)

			const menuItem = menuConstants.MENU_ITEMS.find(x => x.name === payload)
			switch (menuItem && menuItem.name === payload) {
			case true:
				window.location.hash = menuItem.hash
				break
			default:
				window.location.hash = ''
				break
			}
		}
	}
}

</script>

<style scoped></style>
